import TechCard from './TechCard';

export default TechCard;
